/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_OwnerInputs */



/**
* | output |
* | --- |
* | "Subscription Owner" |
*
* @param {Subscription_OwnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_owner = /** @type {((inputs?: Subscription_OwnerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_OwnerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titulaire de l’abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnementinhaber")
	if (locale === "it") return /** @type {LocalizedString} */ ("Titolare dell'abbonamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Владелец подписки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propietario de la suscripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("订阅所有者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプション所有者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता स्वामी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Proprietário da assinatura")
	return /** @type {LocalizedString} */ ("Subscription Owner")
});